(function () {
  'use strict';

  var STORAGE_KEY = 'ticho-theme';
  var OVERRIDE_KEY = 'ticho-theme-override-until';
  var boundaryTimer = null;

  function scheduledTheme(date) {
    var hour = date.getHours();
    return 'day';
  }

  function nextBoundary(date) {
    var next = new Date(date.getTime());
    var hour = date.getHours();

    if (hour < 6) {
      next.setHours(6, 0, 0, 0);
    } else if (hour < 17) {
      next.setHours(17, 0, 0, 0);
    } else {
      next.setDate(next.getDate() + 1);
      next.setHours(6, 0, 0, 0);
    }

    return next.getTime();
  }

  function getOverrideUntil() {
    try {
      return parseInt(localStorage.getItem(OVERRIDE_KEY) || '0', 10) || 0;
    } catch (e) {
      return 0;
    }
  }

  function hasManualOverride() {
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      return stored === 'day' || stored === 'evening';
    } catch (e) {
      return false;
    }
  }

  function apply(theme, userInitiated) {
    var root = document.documentElement;
    root.setAttribute('data-ticho-theme', theme);

    try {
      localStorage.setItem(STORAGE_KEY, theme);
      if (userInitiated) {
        localStorage.setItem(OVERRIDE_KEY, String(nextBoundary(new Date())));
      }
    } catch (e) {
      /* Storage unavailable — current-page theme still applies. */
    }

    var isEvening = theme === 'evening';
    var toggles = document.querySelectorAll('[data-ticho-theme-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var toggle = toggles[i];
      toggle.setAttribute('aria-pressed', isEvening ? 'true' : 'false');
      var label = toggle.getAttribute(isEvening ? 'data-label-day' : 'data-label-evening');
      if (label) toggle.setAttribute('aria-label', label);
    }

    document.dispatchEvent(new CustomEvent('ticho:themechange', {
      detail: { theme: theme, userInitiated: !!userInitiated }
    }));
  }

  function current() {
    return document.documentElement.getAttribute('data-ticho-theme') === 'evening' ? 'evening' : 'day';
  }

  function enforceSchedule() {
    if (hasManualOverride()) return;

    try {
      localStorage.removeItem(OVERRIDE_KEY);
    } catch (e) {
      /* no-op */
    }

    var theme = scheduledTheme(new Date());
    if (current() !== theme) apply(theme, false);
  }

  function scheduleBoundaryCheck() {
    if (boundaryTimer) window.clearTimeout(boundaryTimer);
    var delay = Math.max(1000, nextBoundary(new Date()) - Date.now() + 250);
    boundaryTimer = window.setTimeout(function () {
      try {
        localStorage.removeItem(OVERRIDE_KEY);
      } catch (e) {
        /* no-op */
      }
      enforceSchedule();
      scheduleBoundaryCheck();
    }, delay);
  }

  document.addEventListener('click', function (event) {
    var choice = event.target.closest && event.target.closest('[data-ticho-signature-choice]');
    if (choice) {
      var requested = choice.getAttribute('data-theme') === 'evening' ? 'evening' : 'day';
      if (requested !== current()) apply(requested, true);
      else {
        try {
          localStorage.setItem(OVERRIDE_KEY, String(nextBoundary(new Date())));
        } catch (e) {
          /* no-op */
        }
      }
      scheduleBoundaryCheck();
      return;
    }

    var toggle = event.target.closest && event.target.closest('[data-ticho-theme-toggle]');
    if (!toggle) return;
    apply(current() === 'evening' ? 'day' : 'evening', true);
    scheduleBoundaryCheck();
  });

  function init() {
    if (!hasManualOverride()) {
      apply(scheduledTheme(new Date()), false);
    } else {
      apply(current(), false);
    }
    scheduleBoundaryCheck();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY && event.key !== OVERRIDE_KEY) return;

    if (hasManualOverride()) {
      var stored;
      try {
        stored = localStorage.getItem(STORAGE_KEY);
      } catch (e) {
        stored = null;
      }
      apply(stored === 'evening' ? 'evening' : 'day', false);
    } else {
      enforceSchedule();
    }
    scheduleBoundaryCheck();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      enforceSchedule();
      scheduleBoundaryCheck();
    }
  });
})();
